<template>
  <div>
    <Echart :options="options" id="mapEchart" height="906px" width="100%"></Echart>
  </div>
</template>


<script>
import Echart from "@/components/echart";
import { privinceList } from "./provinces";
export default {
  name: "mapEchart",
  data() {
    return {
      options: {},
    };
  },
  components: {
    Echart,
  },
  props: {
    cdata: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  methods: {},
  watch: {
    cdata: {
      handler(newData) {
        var privinces = privinceList();
        this.cdata.forEach((item) => {
          item.value = item.weeks;
          item.name = privinces[item.provinceId];
        });
        var series = [];
        series.push({
          selectedMode: false, // 禁止地图点击
          type: "map",
          roam: false,
          label: {
            normal: {
              show: true,
              textStyle: {
                color: "#fff",
              },
              formatter: function (params) {
                if (!params.data) {
                  return params.name;
                } else {
                  return `${params.data.billingAmount}\n${params.name}`;
                }
              },
            },
            emphasis: {
              textStyle: {
                color: "#fff",
              },
            },
          },
          itemStyle: {
            normal: {
              borderColor: "rgb(147, 235, 248)",
              borderWidth: 1,
              areaColor: {
                type: "radial",
                x: 0.5,
                y: 0.5,
                r: 0.8,
                colorStops: [
                  {
                    offset: 0,
                    color: "#09132c", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#274d68", // 100% 处的颜色
                  },
                ],
                globalCoord: true, // 缺省为 false
              },
            },
            emphasis: {
              areaColor: this.$echarts.graphic.LinearGradient(1, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#09132c", // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: "#274d68", // 100% 处的颜色
                },
              ]),

              //    shadowColor: 'rgb(12,25,50)',
              borderWidth: 1,
            },
          },
          zoom: 1.1,
          //     roam: false,
          map: "china", //使用
          data: this.cdata,
        });

        this.options = {
          geo: {
            map: "china",
            aspectScale: 0.75, //长宽比
            zoom: 1.1,
            roam: false,
            itemStyle: {
              normal: {
                areaColor: {
                  type: "radial",
                  x: 0.5,
                  y: 0.5,
                  r: 0.8,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#09132c", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#274d68", // 100% 处的颜色
                    },
                  ],
                  globalCoord: true, // 缺省为 false
                },
                shadowColor: "#4cccda",
                shadowOffsetX: 0,
                shadowOffsetY: 12,
              },
              emphasis: {
                areaColor: "#2AB8FF",
                borderWidth: 0,
                color: "green",
                label: {
                  show: false,
                },
              },
            },
            regions: [
              {
                name: "南海诸岛",
                itemStyle: {
                  areaColor: "rgba(0, 10, 52, 1)",
                  borderColor: "rgba(0, 10, 52, 1)",
                  normal: {
                    opacity: 0,
                    label: {
                      show: false,
                      color: "#009cc9",
                    },
                  },
                },
              },
            ],
          },
          visualMap: {
            min: 0,
            max: 7,
            left: 45,
            bottom: 30,
            hoverLink: true,

            realtime: false,
            //平均分层
            splitNumber: 5,
            inRange: {
              color: ["#fff", "#b8ddf0", "#e0bdb8", "#e16f56", "#EB190A"],
            },
            outOfRange: {
              color: ["#fff"],
            },
            textStyle: {
              color: "#fff",
            },

            pieces: [
              // { gte: 1000, lt: 9999, color: "#e64546" },
              { gte: 7, color: "#730000", label: "≥7周" },
              { value: 6, color: "#7E2D00", label: "6周" },
              { value: 5, color: "#955B00", label: "5周" },
              { value: 4, color: "#BA9800", label: "4周" },
              { value: 3, color: "#C6BF00", label: "3周" },
              { value: 2, color: "#B5C500", label: "2周" },
              { value: 1, color: "#88BA1A", label: "1周" },
              { value: 0, color: "#34AE3A", label: "0周" },
            ],
          },
          tooltip: {
            // 提示框组件的配置，也就是鼠标放在图标上显示的描述方框
            trigger: "item",
            showContent: true, // 是否显示提示框
            backgroundColor: "rgba(255,255,255,0.8)", //设置背景图片 rgba格式
            padding: [14, 10, 10, 12],
            textStyle: {
              color: "#4F4F4F", //设置文字颜色
              lineHeight: 16,
              fontSize: 14,
            },
            extraCssText:
              "box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.13), 3px 5px 19px rgba(0, 0, 0, 1);",
            formatter: function (params) {
              var color = params.color; //图例颜色
              if (params.name == 0) {
                params.name = "0";
              }
              var showLable = params.data
                ? `<div>托盘占用数量：${
                    params.data.billingAmount
                  }${"<br />"}送达时长：${params.value}周</div>`
                : "";
              var htmlStr = "<div style=''>";
              htmlStr +=
                '<div style="margin-bottom:8px;"><span style="display:inline-block;width:8px;height:8px;border-radius:5px;margin-right:8px;background-color:' +
                color +
                ';"></span> ' +
                '<span style="display:inline-block;">' +
                params.name +
                "</span></div>" +
                showLable;
              // 文本颜色设置--2020-07-23(需要设置,请解注释下面一行)
              //htmlStr += '</span>';

              htmlStr += "</div>";

              return htmlStr;
            },
          },

          series: series,
        };
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.scatter-content {
  position: absolute;
  bottom: 6%;
  right: 5%;
  // transform: translate(0, 0);
  .scatter {
    display: flex;
    align-items: center;
    margin-bottom: 2px;
    .round {
      border-radius: 50%;
      // background: rgba(255, 0, 0, 0.753);
      // border: 1px solid rgba(255, 0, 0, 0.753);
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      .round1 {
        border-radius: 50%;

        width: 16px;
        height: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        .round2 {
          border-radius: 50%;

          width: 12px;
          height: 12px;
        }
      }
    }
    .txt {
      margin-left: 10px;
      margin-top: 2px;
      color: rgba(255, 255, 255, 0.603);
    }
  }
}
.color1 {
  border: 1px solid rgba(0, 0, 255, 0.534);
}
.backgroud1 {
  background: rgba(0, 0, 255, 0.534);
}
.color2 {
  border: 1px solid #fb6a8796;
}
.backgroud2 {
  background: #fb6a8796;
}
.color3 {
  border: 1px solid rgba(255, 255, 0, 0.534);
}
.backgroud3 {
  background: rgba(255, 255, 0, 0.534);
}
.txt1 {
  color: rgba(0, 0, 255, 0.534);
}
.txt2 {
  color: #fb6a8796;
}
.txt3 {
  color: rgba(255, 255, 0, 0.534);
}
</style>